import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { HttpClient } from "@angular/common/http";
import { MdbModalRef, MdbModalService } from "mdb-angular-ui-kit/modal";
import Swal from "sweetalert2";
import { Router } from "@angular/router";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-reset",
  templateUrl: "./reset.component.html",
  styleUrls: ["./reset.component.scss"],
})
export class ResetComponent implements OnInit {
  firstFormGroup: FormGroup;
  hide = true;
  filled: any;
  lit: any;
  list = [];
  constructor(
    private _formBuilder: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.firstFormGroup = this._formBuilder.group({
      teamid: ["", Validators.required],
    });
  }
  submit2(email: any) {
    var body: any = new FormData();
    body.append("email", email);
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    this.http
      .post<any>(environment.API_URL + "password_reset/", body)
      .subscribe(
        (data) => {
          Swal.fire({
            text: "An email with further steps has been sent to your registered email ID.",
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        },
        (error) => {
          Swal.fire({
            text: "Some error ocurred please contact Admin",
            customClass: {
              popup: "custom-swal-popup",
            },
          });
        }
      );
  }
  submit() {
    var body: any = new FormData();
    body.append("eureka_id", this.firstFormGroup.value.teamid);
    // console.log(this.firstFormGroup.value.teamid)
    const headers = {
      Authorization: "Token " + localStorage.getItem("authToken"),
    };
    // this.http.post<any>(environment.API_URL + "getEmail/", body).subscribe(
    //   data => {
    //     this.lit = data
    //     if(this.lit.email=='' || this.lit.email=='user does not exist'){
    //       Swal.fire('Please enter a valid TeamID')
    //     }
    //     else{
    //       this.submit2(this.lit.email)
    //     }
    //   },
    //   (error) => {
    //     Swal.fire('Please enter a valid TeamID')
    //     this.router.navigate(['/reset']);
    //     }

    //   )
    this.http.post<any>(environment.API_URL + "reset-code/", body).subscribe(
      (data) => {
        Swal.fire(data.status);
      },
      (error) => {
        Swal.fire({
          text: "Please enter a valid TeamID",
          customClass: {
            popup: "custom-swal-popup",
          },
        });
        this.router.navigate(["/reset"]);
      }
    );
  }
}
